module.exports = "/assets/images/eye_83ecaf.svg";